import styles from './style.module.css';

// One thing psy does, on the landing page: a glyph, a title and a sentence.
// icon names the glyph, one of the files beside this component.
export function FeatureCard({ icon, title, children }) {
  return (
    <article className={ styles.card }>
      <span className={ styles.iconBox } aria-hidden='true'>
        <span className={ `${ styles.icon } ${ styles[ icon ] }` }></span>
      </span>

      <h3 className={ styles.title }>{ title }</h3>

      <p className={ styles.text }>{ children }</p>
    </article>
  );
}
